
"use client";

export default function FileIcon({ className = "", ...props }) {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"  className={className}
    {...props}>
    <path d="M28.9523 35.9817H10.5098C9.18377 35.9817 8.09827 34.8962 8.09827 33.5702V5.8898C8.09827 4.56381 9.18377 3.4783 10.5098 3.4783H21.4111C21.9054 3.4783 22.3753 3.66805 22.7261 4.01664C24.7559 6.0288 28.8707 10.0465 30.7902 11.9439C31.1586 12.308 31.3638 12.8022 31.3638 13.3229V33.5702C31.3638 34.8962 30.2783 35.9817 28.9523 35.9817Z" stroke="currentColor" strokeWidth="2.64757" strokeMiterlimit="10" strokeLinecap="round"/>
    <path d="M22.0135 4.70502V11.3747C22.0135 12.2903 22.7614 13.0383 23.677 13.0383H30.0356" stroke="currentColor" strokeWidth="2.64757" strokeMiterlimit="10" strokeLinecap="round"/>
    <path d="M11.6526 19.3285H24.8883" stroke="currentColor" strokeWidth="2.64757" strokeMiterlimit="10"/>
    <path d="M11.6526 24.4758H27.4962" stroke="currentColor" strokeWidth="2.64757" strokeMiterlimit="10"/>
    <path d="M11.6526 29.6209H27.4962" stroke="currentColor" strokeWidth="2.64757" strokeMiterlimit="10"/>
    </svg>
    
  );
}


